module.exports = __webpack_public_path__ + "img/phonics-title.22a3f90c.png";